import type { CustomerRevenueReportItem, RevenuePerMonth, YearlyRevenue } from '@weft/types';
import { entries, extract, isNullOrUndefined, purge, uniqueBy } from '@weft/utils';
import { sortBy } from 'lodash';

export function getTotalCustomerRevenueDateHeaders(reportItems: CustomerRevenueReportItem[]): string[] {
  const yearlyRevenues = extract(reportItems, 'yearlyRevenue');
  const dateStrings = yearlyRevenues.flatMap(getYearlyRevenueDateStrings);
  const uniqueDateStrings = uniqueBy(dateStrings, (dateString) => dateString);

  return sortBy(uniqueDateStrings, (dateString) => {
    const [month, year] = dateString.split(' ');

    return new Date(`${year}-${month}-01`);
  });
}

function getYearlyRevenueDateStrings(yearlyRevenue: YearlyRevenue) {
  return entries(yearlyRevenue).reduce<string[]>((dateStrings, [year, revenuePerMonth]) => {
    const revenuePerMonthStrings = getRevenuePerMonthStrings(revenuePerMonth, year);
    const purgedRevenuePerMonthStrings = purge(revenuePerMonthStrings);

    return [...dateStrings, ...purgedRevenuePerMonthStrings];
  }, []);
}

function getRevenuePerMonthStrings(revenuePerMonth: RevenuePerMonth, year: string | number) {
  return entries(revenuePerMonth).map(([monthKey, revenuePerMonthBreakdown]) => {
    if (isNullOrUndefined(revenuePerMonthBreakdown)) {
      return undefined;
    }

    return `${monthKey} ${year}`;
  });
}